module.exports = __webpack_public_path__ + "static/media/colant.89f24a7d.svg";